import { useAuth } from '~/auth/use-auth';
import { useOrganization } from '~/context/organization/use-org';

export function useCurrentOrganization() {
  const { user } = useAuth();
  const { currentOrganization } = useOrganization();

  // For business users, use current organization URN
  // For individual users, use their user URN
  const isBusinessUser = user?.metadata.usage === 'business';
  const orgUrn =
    isBusinessUser && currentOrganization
      ? currentOrganization.urn
      : user?.urn || '';

  return {
    orgUrn,
    isLoading: false,
    error: null,
    isBusinessUser,
    currentOrganization,
  };
}
